module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"type":"Type"},"de":{"type":"Typ"}}')
  delete Component.options._Ctor
}
